import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getPreventivi from "../services/getPreventivi";
import moment from "moment";
import checkToken from "../services/checkToken";
import editOrdineCsVisione from "../services/editOrdineCsVisione";
import deleteOrdine from "../services/deleteOrdine";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class Preventivi extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
        isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);

    let editPreventivoLink = '';

    this.preventivi = await getPreventivi(username, token);
    this.preventivi.forEach((preventivi, i) => {
      this.preventivi[i].totale_ordine = parseFloat(preventivi.totale_ordine).toFixed(2) + ' €'; 
      this.preventivi[i].aperto_cs = preventivi.aperto_cs === '0' ? 'Non Aperto' : '';
      this.preventivi[i].data_creazione = moment(preventivi.data_creazione, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
    });

    switch(userType) {
      case 0:
        editPreventivoLink = '/#/app/edit-ordine';
        break;
      case 1:
        editPreventivoLink = '/#/tecnico/edit-ordine';
        break;
        case 3:
          editPreventivoLink = '/#/commerciale/edit-ordine';
        break;
        case 4: 
          editPreventivoLink = '/#/service/edit-ordine';
        break;
      default:
        break;
    } 
    
    this.setState({ isLoading: false, isUserType: userType, editPreventivoLink: editPreventivoLink});
  }

  async presaVisione(user, token, idOrdine) {
    const res = await editOrdineCsVisione(user, token, idOrdine);
    if(res.result === 'ok') {
      window.location.href = this.state.editPreventivoLink;
    }
  }

  async componentDidMount(){
    await this.reload();
  }

  async delete(row) {
    if (window.confirm('Sei davvero sicuro di volere eliminare questo preventivo?')) {
      const res = await deleteOrdine(username, token, row);
      if (res.result === 'ok') {
        window.location.reload();
        return;
      }

      alert('Errore nella cancellazione dell\'ordine');
    }
  }

  render () {

    if (this.state.isLoading)
        return <Loading />;

    const cookies = new Cookies();

    var headCells = [
      { id: 'rif', numeric: false, disablePadding: true, label: 'Riferimento' },
      { id: 'ragione_sociale', numeric: true, disablePadding: false, label: 'Cliente' },
      { id: 'totale_ordine', numeric: true, disablePadding: false, label: 'Totale' },
      { id: 'data_creazione', numeric: true, disablePadding: false, label: 'Data Creazione' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    if(this.state.isUserType === 4 && headCells.find((el) => el.id === 'aperto_cs') === undefined) {
      headCells.unshift({ id: 'aperto_cs', disablePadding: false, label: '', icon: true, filter: false });
    }

    this.searchCols = ['rif', 'ragione_sociale', 'data_creazione'];

    return (
      <div id={Math.random()}>

        {
          (this.state.isUserType !== 3) && <PageTitle title="Preventivi" />
        }

        {
          this.state.isUserType === 3 && <PageTitle title="Preventivi" button="CREA NUOVO" onClick={() => {
            this.props.history.push({
              pathname: '/commerciale/add-ordine',
              state: { is_preventivo: true }
            });
          }}/>
        }

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.preventivi} order={'desc'} sortBy={(this.state.isUserType === 0 || this.state.isUserType === 4) ? 1 : 0}
          onEventClick={(row) => {
            cookies.set('ordine', row, { path: '/' });
            if(this.state.isUserType === 4) {
              this.presaVisione(username, token, row);
            } else {
              window.location.href = this.state.editPreventivoLink;
            }
          }}
          onDelete={(this.state.isUserType === 0 || this.state.isUserType === 3) ? this.delete.bind(this) : null}
        />
      </div>
    );
  }
}

